export default (event, onSubmit, {formState, validateForm, getFormData, getFormStateSync,}) => {
    event.preventDefault();
    validateForm();
    const {isValid, ...rest} = getFormStateSync();
    if (isValid) {
        onSubmit(getFormData(rest));
    }
};
